import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  styled,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { useGetOrgIdentifier } from "../../generic/hooks/useGetOrgIdentifier";
import apiService from "../../../service/apiservice/apiService";

const CustomOutlinedInput = styled(OutlinedInput)(({ theme }) => ({
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "var(--main-theme-color) !important",
    borderWidth: "1px !important",
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const FacilitySelect = ({ patient, handleChange, required, error }) => {
  const organizationIdentifier = useGetOrgIdentifier();
  const [facilities, setFacilities] = useState([]);

  const facility = useMemo(() => {
    if (!facilities || !patient?.facilityId) return null;
    return (
      facilities.find((item) => item?.facilityId === patient?.facilityId) ||
      null
    );
  }, [facilities, patient?.facilityId]);

  useEffect(() => {
    const getFacilities = async () => {
      const endpoint = "niramayafoundation/api/v1/facilities";
      const params = {
        facilityOrganizationId: organizationIdentifier,
      };
      const response = await apiService.get(endpoint, params);
      setFacilities(response);
    };

    getFacilities();
  }, [organizationIdentifier]);

  return (
    <FormControl
      fullWidth
      className="add-edit-select"
      required={required}
      error={error?.facility}
    >
      <InputLabel id="facility">Facility</InputLabel>
      <Select
        labelId="facility"
        value={facility || ""}
        onChange={handleChange}
        name="facilityId"
        input={<CustomOutlinedInput label="Facility" />}
        renderValue={(selected) => selected?.facilityName || ""}
        MenuProps={MenuProps}
      >
        {facilities?.map((item) => (
          <MenuItem value={item} key={item?.facilityId}>
            {item?.facilityName}
          </MenuItem>
        ))}
      </Select>
      {error?.facility && <FormHelperText>{error?.facility}</FormHelperText>}
    </FormControl>
  );
};

export default FacilitySelect;
